export interface ProductPresentation {
  /** Etiqueta de presentación: '250g', '500ml', 'Frasco 200g', 'Caja 20 sobres', ... */
  presentacion: string;
  precio: number;
}

export interface Product {
  id: string;
  slug: string;
  name: string;
  categoria: string;
  etiquetas: string[];
  descripcion: string;
  presentaciones: ProductPresentation[];
  imagen: string;
  imagenesAdicionales?: string[];
}

export const productos: Product[] = [
  // ==========================================================
  // FRUTOS SECOS Y SEMILLAS
  // ==========================================================
  {
    id: 'pecanas',
    slug: 'pecanas-naturales',
    name: 'Pecanas Peladas',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['alto en fibra', 'omega', 'proteína vegetal', 'sin gluten', 'apto lonchera'],
    descripcion: 'Pecanas peladas, ricas en omega-3 y antioxidantes. Perfectas para el snack saludable de toda la familia.',
    presentaciones: [
      { presentacion: '250g', precio: 13.90 },
      { presentacion: '500g', precio: 24.90 },
      { presentacion: '1kg', precio: 44.00 }
    ],
    imagen: '/placeholder-pecanas.jpg'
  },
  {
    id: 'almendras',
    slug: 'almendras-naturales',
    name: 'Almendras Naturales',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['alto en fibra', 'proteína vegetal', 'sin gluten', 'vitamina E'],
    descripcion: 'Almendras seleccionadas, fuente natural de vitamina E y magnesio. Ideales para nutrir el cerebro y fortalecer el sistema inmunológico.',
    presentaciones: [
      { presentacion: '250g', precio: 11.90 },
      { presentacion: '500g', precio: 21.90 },
      { presentacion: '1kg', precio: 38.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },
  {
    id: 'semillas-chia',
    slug: 'semillas-chia-organica',
    name: 'Semillas de Chía Orgánica',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['omega', 'alto en fibra', 'sin gluten', 'superalimento peruano', 'apto lonchera'],
    descripcion: 'Chía orgánica peruana, rica en omega-3, fibra y proteína completa. Perfecta para agregar a jugos, yogures y postres.',
    presentaciones: [
      { presentacion: '250g', precio: 12.90 },
      { presentacion: '500g', precio: 23.90 },
      { presentacion: '1kg', precio: 44.90 }
    ],
    imagen: '/placeholder-chia.jpg'
  },
  {
    id: 'sacha-inchi',
    slug: 'sacha-inchi-tostado',
    name: 'Sacha Inchi Tostado',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['omega', 'proteína vegetal', 'sin gluten', 'superalimento peruano'],
    descripcion: 'Maní del inca tostado, el superalimento amazónico con el mayor contenido de omega-3 vegetal. Crujiente y nutritivo.',
    presentaciones: [
      { presentacion: '250g', precio: 22.90 },
      { presentacion: '500g', precio: 42.90 },
      { presentacion: '1kg', precio: 79.90 }
    ],
    imagen: '/placeholder-sacha-inchi.jpg'
  },
  {
    id: 'pecanas-cascara',
    slug: 'pecanas-con-cascara',
    name: 'Pecanas con Cáscara',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['alto en fibra', 'omega', 'sin gluten', 'apto lonchera'],
    descripcion: 'Pecanas enteras con cáscara, para picar en casa. Se conservan mejor y rinden en la lonchera o en la mesa.',
    presentaciones: [
      { presentacion: '250g', precio: 7.90 },
      { presentacion: '500g', precio: 13.50 },
      { presentacion: '1kg', precio: 24.00 }
    ],
    imagen: '/placeholder-pecanas.jpg'
  },
  {
    id: 'nueces-peladas',
    slug: 'nueces-peladas',
    name: 'Nueces Peladas',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['omega', 'sin gluten', 'apto lonchera'],
    descripcion: 'Nueces peladas, listas para comer o para agregar a ensaladas, desayunos y repostería.',
    presentaciones: [
      { presentacion: '250g', precio: 14.90 },
      { presentacion: '500g', precio: 26.90 },
      { presentacion: '1kg', precio: 48.00 }
    ],
    imagen: '/placeholder-pecanas.jpg'
  },
  {
    id: 'nueces-cascara',
    slug: 'nueces-con-cascara',
    name: 'Nueces con Cáscara',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['omega', 'sin gluten', 'apto lonchera'],
    descripcion: 'Nueces enteras con cáscara. Una presentación más económica para tener en casa y abrir al momento.',
    presentaciones: [
      { presentacion: '250g', precio: 7.90 },
      { presentacion: '500g', precio: 13.50 },
      { presentacion: '1kg', precio: 24.00 }
    ],
    imagen: '/placeholder-pecanas.jpg'
  },
  {
    id: 'pistachos',
    slug: 'pistachos',
    name: 'Pistachos',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['proteína vegetal', 'sin gluten', 'apto lonchera'],
    descripcion: 'Pistachos para picar. Un fruto seco sabroso, práctico para compartir en casa o llevar en la lonchera.',
    presentaciones: [
      { presentacion: '250g', precio: 19.90 },
      { presentacion: '500g', precio: 35.90 },
      { presentacion: '1kg', precio: 64.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },
  {
    id: 'pasas',
    slug: 'pasas',
    name: 'Pasas',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['alto en fibra', 'sin gluten', 'apto lonchera'],
    descripcion: 'Pasas naturales, dulces y blandas. Sirven para el desayuno, la repostería y el refrigerio de los niños.',
    presentaciones: [
      { presentacion: '250g', precio: 2.90 },
      { presentacion: '500g', precio: 4.50 },
      { presentacion: '1kg', precio: 8.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },
  {
    id: 'pasas-rubias',
    slug: 'pasas-rubias',
    name: 'Pasas Rubias',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['alto en fibra', 'sin gluten', 'apto lonchera'],
    descripcion: 'Pasas rubias, de sabor más suave que la pasa oscura. Buenas para postres, granola y snacks.',
    presentaciones: [
      { presentacion: '250g', precio: 8.90 },
      { presentacion: '500g', precio: 15.90 },
      { presentacion: '1kg', precio: 28.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },
  {
    id: 'mani-tostado',
    slug: 'mani-tostado',
    name: 'Maní Tostado',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['proteína vegetal', 'apto lonchera'],
    descripcion: 'Maní tostado, crocante y listo para comer. Una opción sencilla y económica para la lonchera o el picoteo.',
    presentaciones: [
      { presentacion: '250g', precio: 3.90 },
      { presentacion: '500g', precio: 6.90 },
      { presentacion: '1kg', precio: 12.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },
  {
    id: 'higos-secos',
    slug: 'higos-secos',
    name: 'Higos Secos',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['alto en fibra', 'sin gluten', 'apto lonchera'],
    descripcion: 'Higos secos, dulces y con fibra. Se comen solos o se agregan a yogur, avena y postres.',
    presentaciones: [
      { presentacion: '250g', precio: 5.90 },
      { presentacion: '500g', precio: 9.90 },
      { presentacion: '1kg', precio: 18.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },
  {
    id: 'caju-tostado',
    slug: 'caju-tostado',
    name: 'Cajú Tostado',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['proteína vegetal', 'sin gluten', 'apto lonchera'],
    descripcion: 'Cajú tostado (marañón), de textura cremosa. Para picar, cocinar o sumar a la lonchera.',
    presentaciones: [
      { presentacion: '250g', precio: 13.90 },
      { presentacion: '500g', precio: 24.90 },
      { presentacion: '1kg', precio: 45.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },
  {
    id: 'arandanos',
    slug: 'arandanos-deshidratados',
    name: 'Arándanos Deshidratados',
    categoria: 'Frutos secos y semillas',
    etiquetas: ['alto en fibra', 'sin gluten', 'apto lonchera'],
    descripcion: 'Arándanos deshidratados, dulces y prácticos. Ideales para avena, yogur, repostería y snacks.',
    presentaciones: [
      { presentacion: '250g', precio: 11.90 },
      { presentacion: '500g', precio: 21.90 },
      { presentacion: '1kg', precio: 38.00 }
    ],
    imagen: '/placeholder-almendras.jpg'
  },

  // ==========================================================
  // GRANOS Y CEREALES
  // ==========================================================
  {
    id: 'quinua-blanca',
    slug: 'quinua-blanca-real',
    name: 'Quinua Blanca Real',
    categoria: 'Granos y cereales',
    etiquetas: ['proteína vegetal', 'sin gluten', 'superalimento peruano', 'grano andino'],
    descripcion: 'Quinua real boliviana, el grano de oro de los incas. Proteína completa, sin gluten, perfecta para toda la familia.',
    presentaciones: [
      { presentacion: '250g', precio: 8.90 },
      { presentacion: '500g', precio: 16.90 },
      { presentacion: '1kg', precio: 31.90 }
    ],
    imagen: '/placeholder-quinua.jpg'
  },
  {
    id: 'kiwicha',
    slug: 'kiwicha-amaranto-peruano',
    name: 'Kiwicha (Amaranto Peruano)',
    categoria: 'Granos y cereales',
    etiquetas: ['proteína vegetal', 'sin gluten', 'grano andino', 'alto en hierro'],
    descripcion: 'Amaranto peruano ancestral, rico en proteína y minerales. Ideal para preparar desayunos nutritivos y reventado.',
    presentaciones: [
      { presentacion: '250g', precio: 9.90 },
      { presentacion: '500g', precio: 18.90 },
      { presentacion: '1kg', precio: 35.90 }
    ],
    imagen: '/placeholder-kiwicha.jpg'
  },
  {
    id: 'cañihua',
    slug: 'cañihua-grano-andino',
    name: 'Cañihua Grano Andino',
    categoria: 'Granos y cereales',
    etiquetas: ['proteína vegetal', 'sin gluten', 'grano andino', 'alto en hierro'],
    descripcion: 'Cañihua del altiplano peruano, pequeño grano con gran valor nutricional. Rico en proteínas y minerales esenciales.',
    presentaciones: [
      { presentacion: '250g', precio: 11.90 },
      { presentacion: '500g', precio: 21.90 },
      { presentacion: '1kg', precio: 40.90 }
    ],
    imagen: '/placeholder-canihua.jpg'
  },
  {
    id: 'arroz-integral',
    slug: 'arroz-integral-organico',
    name: 'Arroz Integral Orgánico',
    categoria: 'Granos y cereales',
    etiquetas: ['alto en fibra', 'grano integral', 'vitaminas B'],
    descripcion: 'Arroz integral orgánico, conserva todos sus nutrientes y fibra natural. Base perfecta para una alimentación saludable.',
    presentaciones: [
      { presentacion: '500g', precio: 7.90 },
      { presentacion: '1kg', precio: 14.90 }
    ],
    imagen: '/placeholder-arroz-integral.jpg'
  },

  // ==========================================================
  // LEGUMBRES
  // ==========================================================
  {
    id: 'lentejas-rojas',
    slug: 'lentejas-rojas-partidas',
    name: 'Lentejas Rojas Partidas',
    categoria: 'Legumbres',
    etiquetas: ['proteína vegetal', 'alto en hierro', 'alto en fibra', 'cocción rápida'],
    descripcion: 'Lentejas rojas partidas, cocción rápida y alto valor proteico. Perfectas para sopas nutritivas y guisos familiares.',
    presentaciones: [
      { presentacion: '250g', precio: 6.90 },
      { presentacion: '500g', precio: 12.90 },
      { presentacion: '1kg', precio: 23.90 }
    ],
    imagen: '/placeholder-lentejas.jpg'
  },
  {
    id: 'garbanzos',
    slug: 'garbanzos-secos',
    name: 'Garbanzos Secos',
    categoria: 'Legumbres',
    etiquetas: ['proteína vegetal', 'alto en fibra', 'hierro', 'versátil'],
    descripcion: 'Garbanzos selectos, ricos en proteína vegetal y fibra. Ideales para hummus, guisos y ensaladas nutritivas.',
    presentaciones: [
      { presentacion: '250g', precio: 5.90 },
      { presentacion: '500g', precio: 10.90 },
      { presentacion: '1kg', precio: 19.90 }
    ],
    imagen: '/placeholder-garbanzos.jpg'
  },
  {
    id: 'tarwi',
    slug: 'tarwi-chocho-peruano',
    name: 'Tarwi (Chocho Peruano)',
    categoria: 'Legumbres',
    etiquetas: ['proteína vegetal', 'superalimento peruano', 'alto en hierro', 'legumbre andina'],
    descripcion: 'Tarwi andino desamargado, la legumbre con mayor contenido proteico. Tradición nutricional de los Andes peruanos.',
    presentaciones: [
      { presentacion: '250g', precio: 13.90 },
      { presentacion: '500g', precio: 25.90 },
      { presentacion: '1kg', precio: 47.90 }
    ],
    imagen: '/placeholder-tarwi.jpg'
  },

  // ==========================================================
  // HARINAS
  // ==========================================================
  {
    id: 'harina-quinua',
    slug: 'harina-quinua-integral',
    name: 'Harina de Quinua Integral',
    categoria: 'Harinas',
    etiquetas: ['sin gluten', 'proteína vegetal', 'harina andina', 'repostería saludable'],
    descripcion: 'Harina de quinua 100% natural, perfecta para repostería sin gluten y preparaciones nutritivas para toda la familia.',
    presentaciones: [
      { presentacion: '250g', precio: 9.90 },
      { presentacion: '500g', precio: 18.90 },
      { presentacion: '1kg', precio: 35.90 }
    ],
    imagen: '/placeholder-harina-quinua.jpg'
  },
  {
    id: 'harina-maca',
    slug: 'harina-maca-gelatinizada',
    name: 'Harina de Maca Gelatinizada',
    categoria: 'Harinas',
    etiquetas: ['superalimento peruano', 'energizante natural', 'adaptógeno', 'raíz andina'],
    descripcion: 'Maca gelatinizada en polvo, más fácil digestión. El energizante natural de los Andes peruanos, ideal para batidos.',
    presentaciones: [
      { presentacion: '250g', precio: 15.90 },
      { presentacion: '500g', precio: 29.90 }
    ],
    imagen: '/placeholder-harina-maca.jpg'
  },
  {
    id: 'harina-avena',
    slug: 'harina-avena-integral',
    name: 'Harina de Avena Integral',
    categoria: 'Harinas',
    etiquetas: ['alto en fibra', 'beta glucanos', 'repostería saludable', 'grano integral'],
    descripcion: 'Harina de avena integral, rica en beta-glucanos y fibra soluble. Perfecta para panqueques, galletas y panes saludables.',
    presentaciones: [
      { presentacion: '250g', precio: 7.90 },
      { presentacion: '500g', precio: 14.90 },
      { presentacion: '1kg', precio: 27.90 }
    ],
    imagen: '/placeholder-harina-avena.jpg'
  },
  {
    id: 'avena-integral-precocida',
    slug: 'avena-integral-precocida',
    name: 'Avena Integral Precocida "Grano de Oro"',
    categoria: 'Granos y cereales',
    etiquetas: ['alto en fibra', 'beta glucanos', 'sin gluten', 'desayuno energético'],
    descripcion: 'Avena integral precocida en empaque de papel kraft. Hojuelas suaves, ricas en beta-glucanos, listas para tu desayuno energético.',
    presentaciones: [
      { presentacion: '500g', precio: 6.90 },
      { presentacion: '1kg', precio: 12.90 }
    ],
    imagen: '/images/productos/avena-integral.jpg'
  },
  {
    id: 'avena-cereales-granel',
    slug: 'avena-cereales-granel',
    name: 'Avena y Cereales a Granel',
    categoria: 'Granos y cereales',
    etiquetas: ['venta a granel', 'alto en fibra', 'económico', 'desayuno energético'],
    descripcion: 'Avena y cereales seleccionados en venta a granel. Compra la cantidad exacta que necesitas, con pala medidora incluida.',
    presentaciones: [
      { presentacion: '500g', precio: 5.50 },
      { presentacion: '1kg', precio: 10.90 }
    ],
    imagen: '/images/productos/avena-granel.jpg'
  },
  {
    id: 'mezcla-andina-7-semillas',
    slug: 'mezcla-andina-7-semillas',
    name: 'Mezcla Andina de 7 Semillas',
    categoria: 'Harinas',
    etiquetas: ['superalimento peruano', 'omega', 'alto en fibra', 'sin gluten'],
    descripcion: 'Mezcla andina de 7 semillas tostadas y molidas en empaque kraft con ilustraciones andinas. Perfecta para enriquecer batidos, yogures y postres.',
    presentaciones: [
      { presentacion: '250g', precio: 9.90 },
      { presentacion: '500g', precio: 18.90 }
    ],
    imagen: '/images/productos/mezcla-7-semillas.jpg'
  },
  {
    id: 'carne-soya',
    slug: 'carne-soya-texturizada',
    name: 'Carne de Soya Texturizada',
    categoria: 'Granos y cereales',
    etiquetas: ['proteína vegetal', 'cocción rápida', 'versátil', 'sin gluten'],
    descripcion: 'Carne de soya texturizada en caja, la base proteica perfecta para guisos, bolognesas y recetas vegetarianas rápidas.',
    presentaciones: [
      { presentacion: '250g', precio: 8.90 },
      { presentacion: '500g', precio: 15.90 },
      { presentacion: 'Caja 1kg', precio: 28.90 }
    ],
    imagen: '/images/productos/carne-soya.jpg'
  },
  {
    id: 'soya-hojuelas',
    slug: 'soya-en-hojuelas',
    name: 'Soya en Hojuelas',
    categoria: 'Granos y cereales',
    etiquetas: ['proteína vegetal', 'alto en fibra', 'versátil'],
    descripcion: 'Soya en hojuelas, versátil y económica. Ideal para crocantes, guisos y preparaciones ricas en proteína vegetal.',
    presentaciones: [
      { presentacion: '500g', precio: 7.90 },
      { presentacion: 'Bolsa 1kg', precio: 13.90 }
    ],
    imagen: '/images/productos/soya-hojuelas.jpg'
  },
  {
    id: 'fideos-artesanales',
    slug: 'fideos-artesanales-integrales',
    name: 'Fideos Artesanales Integrales',
    categoria: 'Granos y cereales',
    etiquetas: ['grano integral', 'alto en fibra', 'artesanal'],
    descripcion: 'Fideos artesanales de harina integral en empaques alargados. Textura firme y sabor a cereal tostado, elaborados a mano.',
    presentaciones: [
      { presentacion: '250g', precio: 5.90 },
      { presentacion: '500g', precio: 10.90 }
    ],
    imagen: '/images/productos/fideos-artesanales.jpg'
  },

  // ==========================================================
  // ACEITES Y VINAGRES
  // ==========================================================
  {
    id: 'aceite-oliva',
    slug: 'aceite-oliva-extra-virgen',
    name: 'Aceite de Oliva Extra Virgen',
    categoria: 'Aceites y vinagres',
    etiquetas: ['prensado en frío', 'omega', 'antioxidante', 'vitamina E'],
    descripcion: 'Aceite de oliva extra virgen prensado en frío, en botella de vidrio oscuro que protege sus antioxidantes. Ideal para aderezos y cocina fría.',
    presentaciones: [
      { presentacion: '250ml', precio: 22.90 },
      { presentacion: '500ml', precio: 38.90 },
      { presentacion: '1L', precio: 64.90 }
    ],
    imagen: '/images/productos/aceite-oliva.jpg'
  },
  {
    id: 'aceite-palta',
    slug: 'aceite-de-palta',
    name: 'Aceite de Palta',
    categoria: 'Aceites y vinagres',
    etiquetas: ['prensado en frío', 'omega', 'antioxidante', 'corazón saludable'],
    descripcion: 'Aceite de palta prensado en frío, de un punto de humo alto y sabor suave. La alternativa saludable para cocinar y aderezar.',
    presentaciones: [
      { presentacion: '250ml', precio: 32.90 },
      { presentacion: '500ml', precio: 58.90 }
    ],
    imagen: '/images/productos/aceite-palta.jpg'
  },
  {
    id: 'aceite-coco',
    slug: 'aceite-de-coco-organico',
    name: 'Aceite de Coco Orgánico',
    categoria: 'Aceites y vinagres',
    etiquetas: ['energizante natural', 'sin gluten', 'multiuso', 'superalimento peruano'],
    descripcion: 'Aceite de coco orgánico en frasco de vidrio, estado sólido natural. Ideal para repostería, batidos y cuidado de la piel.',
    presentaciones: [
      { presentacion: 'Frasco 200g', precio: 16.90 },
      { presentacion: 'Frasco 450g', precio: 29.90 }
    ],
    imagen: '/images/productos/aceite-coco.jpg'
  },
  {
    id: 'vinagre-manzana',
    slug: 'vinagre-de-manzana',
    name: 'Vinagre de Manzana Natural',
    categoria: 'Aceites y vinagres',
    etiquetas: ['salud digestiva', 'sin azúcar', 'sin aditivos'],
    descripcion: 'Vinagre de manzana natural, fermentado y sin filtrar. Aliado digestivo perfecto para aderezos, bebidas y marinadas.',
    presentaciones: [
      { presentacion: '500ml', precio: 9.90 },
      { presentacion: '1L', precio: 16.90 }
    ],
    imagen: '/images/productos/vinagre-manzana.jpg'
  },
  {
    id: 'extractos-esencias',
    slug: 'extractos-esencias-naturales',
    name: 'Extractos y Esencias Naturales',
    categoria: 'Aceites y vinagres',
    etiquetas: ['repostería saludable', 'sin aditivos', 'artesanal'],
    descripcion: 'Extractos y esencias naturales (vainilla, menta y más) en frasquitos de tapa verde. Intensidad aromática real para tus postres y bebidas.',
    presentaciones: [
      { presentacion: 'Frasco 30ml', precio: 8.50 },
      { presentacion: 'Frasco 60ml', precio: 13.90 }
    ],
    imagen: '/images/productos/extractos-esencias.jpg'
  },

  // ==========================================================
  // SUPeralimentos y endulzantes
  // ==========================================================
  {
    id: 'sal-maras',
    slug: 'sal-rosada-maras',
    name: 'Sal Rosada de Maras',
    categoria: 'Superalimentos y endulzantes',
    etiquetas: ['superalimento peruano', 'rico en minerales', 'artesanal'],
    descripcion: 'Sal rosada de las salineras de Maras, Cusco. Recolectada a mano y rica en minerales, con un toque gourmet para tus platillos.',
    presentaciones: [
      { presentacion: '250g', precio: 6.90 },
      { presentacion: '500g', precio: 12.50 },
      { presentacion: 'Frasco 1kg', precio: 21.90 }
    ],
    imagen: '/images/productos/sal-maras.jpg'
  },
  {
    id: 'levadura-cerveza',
    slug: 'levadura-de-cerveza',
    name: 'Levadura de Cerveza',
    categoria: 'Superalimentos y endulzantes',
    etiquetas: ['proteína vegetal', 'vitaminas B', 'sin gluten', 'salud digestiva'],
    descripcion: 'Levadura de cerveza en copos, fuente natural de vitaminas del complejo B y proteínas. El aliado vegano para dar sabor a tus platos.',
    presentaciones: [
      { presentacion: 'Frasco 200g', precio: 12.90 },
      { presentacion: 'Frasco 400g', precio: 22.90 }
    ],
    imagen: '/images/productos/levadura-cerveza.jpg'
  },
  {
    id: 'polen-abeja',
    slug: 'polen-de-abeja-granulos',
    name: 'Polen de Abeja en Gránulos',
    categoria: 'Superalimentos y endulzantes',
    etiquetas: ['energizante natural', 'vitaminas B', 'antioxidante', 'apto lonchera'],
    descripcion: 'Polen de abeja en gránulos, recogido de colmenas peruanas. Superfood energizante rico en aminoácidos y vitaminas.',
    presentaciones: [
      { presentacion: '250g', precio: 24.90 },
      { presentacion: '500g', precio: 45.90 }
    ],
    imagen: '/images/productos/polen-abeja.jpg'
  },
  {
    id: 'miel-pura',
    slug: 'miel-de-abeja-pura',
    name: 'Miel de Abeja Pura',
    categoria: 'Superalimentos y endulzantes',
    etiquetas: ['endulzante natural', 'sin aditivos', 'energizante natural', 'antioxidante'],
    descripcion: 'Miel de abeja pura de valles peruanos, sin procesar ni pasteurizar. Endulzante natural en frasco de vidrio, con todo su aroma floral.',
    presentaciones: [
      { presentacion: '250g', precio: 10.90 },
      { presentacion: '500g', precio: 18.90 },
      { presentacion: 'Pote 1kg', precio: 30.90 }
    ],
    imagen: '/images/productos/miel-pura.jpg'
  },
  {
    id: 'algarrobina',
    slug: 'algarrobina',
    name: 'Algarrobina Pura',
    categoria: 'Superalimentos y endulzantes',
    etiquetas: ['endulzante natural', 'alto en hierro', 'superalimento peruano', 'energizante natural'],
    descripcion: 'Algarrobina pura, el sirope denso y oscuro del algarrobo peruano. Endulzante natural rico en hierro, perfecto para batidos y postres.',
    presentaciones: [
      { presentacion: 'Frasco 250ml', precio: 8.90 },
      { presentacion: 'Frasco 500ml', precio: 15.90 }
    ],
    imagen: '/images/productos/algarrobina.jpg'
  },
  {
    id: 'te-verde-infusiones',
    slug: 'te-verde-infusiones',
    name: 'Té Verde e Infusiones Naturales',
    categoria: 'Superalimentos y endulzantes',
    etiquetas: ['antioxidante', 'sin cafeína', 'sin aditivos', 'salud digestiva'],
    descripcion: 'Selección de té verde e infusiones funcionales en cajas de sobres. Antioxidantes y calma en cada taza, para todos los momentos del día.',
    presentaciones: [
      { presentacion: 'Caja 20 sobres', precio: 7.90 },
      { presentacion: 'Caja 40 sobres', precio: 14.50 }
    ],
    imagen: '/images/productos/te-verde.jpg'
  }
];

// ============================================================
// Utilidades derivadas de los datos (única fuente de verdad)
// ============================================================

/** Categorías únicas en orden de aparición (para filtros y navegación) */
export const categorias: string[] = Array.from(
  new Set(productos.map((p) => p.categoria))
);

/** Etiquetas únicas en orden de aparición (para filtros) */
export const etiquetas: string[] = Array.from(
  new Set(productos.flatMap((p) => p.etiquetas))
);

/** Extrae el tamaño normalizado de una etiqueta de presentación. */
export const normalizarPresentacion = (label: string): string | null => {
  const match = label.match(/(\d+(?:\.\d+)?)\s*(kg|g|ml|L)\b/);
  return match ? `${match[1]}${match[2]}` : null;
};

const unidadEscala: Record<string, number> = { g: 1, kg: 1000, ml: 1, L: 1000 };

/** Presentaciones (formatos) únicas, ordenadas de menor a mayor tamaño */
export const presentaciones: string[] = Array.from(
  new Set(
    productos.flatMap((p) =>
      p.presentaciones
        .map((pres) => normalizarPresentacion(pres.presentacion))
        .filter((v): v is string => v !== null)
    )
  )
).sort((a, b) => {
  const valor = (s: string) => {
    const m = s.match(/(\d+(?:\.\d+)?)\s*(kg|g|ml|L)/);
    return m ? parseFloat(m[1]) * unidadEscala[m[2]] : Number.MAX_SAFE_INTEGER;
  };
  return valor(a) - valor(b);
});